global.fetch = require('node-fetch');
const AWSCognito = require('amazon-cognito-identity-js');
const AWS = require('aws-sdk');

/**
* imon 환경변수
* @see imon_env.js 
*/
// const cognito_pool_data = JSON.parse(process.env.IMON_ENV).aws_cognito.imon_user_pool;
// const cognito_pool_data = 'ap-northeast-2_jQKm5zafX';
const cognito_admin_pool_data = {
    'UserPoolId': 'ap-northeast-2_yZEfMjC7n',   // #코그니토 관리자 풀 아이디
    'ClientId': '4i01svk4hubsfmaf2o92m1m9tl',    // #코그니토 관리자 풀에서 등록한 clientID
    'region': 'ap-northeast-2',
    'IdentityPoolId': 'ap-northeast-2:c26215ff-5bec-4346-a1d8-d25aa6852e3c', // imon_user_identity_pool 
};

/**
* AWS Cognito와 관련된 기능을 모아 놓고 관리하는 class
*/
const class_imon_user_cognito_handler = function (cognito_pool) {

    const cognito_pool_data = cognito_pool || cognito_admin_pool_data;
    // console.log('class_imon_cognito_warpper {}', cognito_pool_data);
    const user_pool = new AWSCognito.CognitoUserPool(cognito_pool_data);

    /**
     * 코그니토에 계정을 신규 등록한다.
     * @param username 
     * @param email
     * @param password 
     * @param callback function
     */
    this.sign_up = (username, email, password, gateway_serial_no, app_version, app_lang, callback) => {
        const email_model = new cognito_email_model(email);
        const gw_model = new cognito_user_attribure_model('custom:gateway_serial_no', gateway_serial_no);
        const app_version_model = new cognito_user_attribure_model('custom:app_version', app_version);
        const app_lang_model = new cognito_user_attribure_model('custom:app_lang', app_lang);
        const user_attributes = this.cognito_user_attributes(email_model, gw_model, app_version_model, app_lang_model);
        user_pool.signUp(username, password, user_attributes, null, callback);
    };

    /**
     * 코그니토에 계정등록 후 등록된 email로 인증정보를 발송하고 발송된 OTP코드로 email인증을 한다.
     * 여기까지 정상적으로 되어야 imon 서비스를 사용할 수 있는 준비단계가 된다.
     * @param username 
     * @param otp 
     * @param callback function
     */
    this.confirm_registration = (username, otp, callback) => {
        const user_pool_model = new cognito_user_model(username, user_pool);
        const cognito_user = new AWSCognito.CognitoUser(user_pool_model);
        cognito_user.confirmRegistration(otp, true, callback);
    };

    /**
     * 이메일 변경 후 본인 이메일이 맞는지 검증한다.
     * @param username 
     * @param otp 
     * @param callback function
     */
    this.confirm_verify_attribute = (username, otp, callback) => {

        const user_pool_model = new cognito_user_model(username, user_pool);
        const cognito_user = new AWSCognito.CognitoUser(user_pool_model);

        cognito_user.getSession((err, session) => {
            // console.log(err, session);
            cognito_user.verifyAttribute('email', otp, {
                onSuccess: function (result) {
                    console.log('call result: ' + result);
                    return callback(null, result);
                },
                onFailure: function (err) {
                    console.log(err)
                    return callback(err);
                }
            });
        });

    };
    /**
     * 코그니토에 로그인을 하고 사용자 토큰 정보를 가저온다.
     * @param username 
     * @param password 
     * @param callback function
     */
    this.user_account_login = (username, password, callback) => {
        const me = this;
        const user_login_model = new cognito_login_model(username, password);
        const user_pool_model = new cognito_user_model(username, user_pool);
        const cognito_user = new AWSCognito.CognitoUser(user_pool_model);
        const authentication_details = new AWSCognito.AuthenticationDetails(user_login_model);
        console.log('call')
        cognito_user.authenticateUser(authentication_details, {
            onSuccess: function (result) {
                cognito_user.getSession((err, session) => {
                    if (err) return callback(err);
                    cognito_user.setSignInUserSession(session);
                    return callback(null, session);
                });

            },
            onFailure: function (err) {
                console.log(err);
                if(err.code && err.code == 'PasswordResetRequiredException') {
                    let code = prompt('비밀번호가 만료되어 새로운 비밀번호를 입력해야 합니다. 가입시 입력된 이메일로 확인코드가 전송되었으니 확인코드를 확인 후 입력하여주세요.');
                    let new_password = prompt('변경할 비밀번호를 입력하세요.');
                    me.confirm_password(username, code, new_password, callback);
                    return;
                }
                return callback(err);
            },
            newPasswordRequired: function (userAttributes, requiredAttributes) {
                console.log(userAttributes, requiredAttributes);
                let name = prompt('관리자 이름 또는 별칭을 입력하세요.');
                userAttributes.name = name;
                let newPassword = prompt('변경할 비밀번호를 입력하세요.');
                
                cognito_user.completeNewPasswordChallenge(newPassword, {name:name}, this);
            }
        });
    };

    this.user_account_logout = () => {
        const username = this.getUserName();
        if(username) {
            const user_pool_model = new cognito_user_model(username, user_pool);
            const cognito_user = new AWSCognito.CognitoUser(user_pool_model);
            cognito_user.signOut();
        }

    }

    /**
      * 인증된 사용자의 비밀번호를 변경한다.
      * @param username 
      * @param old_password 
      * @param new_password
      * @param callback function
      */
    this.user_account_change_password = (username, old_password, new_password, callback) => {

        const user_pool_model = new cognito_user_model(username, user_pool);
        const cognito_user = new AWSCognito.CognitoUser(user_pool_model);

        cognito_user.getSession((err, session) => {
            // console.log(err, session);
            cognito_user.changePassword(old_password, new_password, callback);
        });
    };

    /**
     * 인증된 사용자의 이메일주소를 변경한다.
     * @param username 
     * @param old_password 
     * @param new_password
     * @param callback function
     */
    this.change_email_address = (username, email, callback) => {
        console.log('change_email_address', username, email)
        const cognito_user = new AWSCognito.CognitoUser(new cognito_user_model(username, user_pool));
        cognito_user.getSession((err, session) => {
            if (err) callback(err);
            const email_model = new cognito_email_model(email);
            const user_attributes = this.cognito_user_attributes(email_model);
            cognito_user.updateAttributes(user_attributes, callback);
        });

    };

    /**
     * 미인증 사용자의 비밀번호 찾기
     * @param username 
     * @param old_password 
     * @param new_password
     * @param callback function
     */
    this.forgot_password = (username, callback) => {

        try {
            const cognito_user = new AWSCognito.CognitoUser(new cognito_user_model(username, user_pool));
            cognito_user.forgotPassword({
                onSuccess: function (result) {
                    // console.log('call result: ' + result);
                    return callback(null, result);
                },
                onFailure: function (err) {
                    return callback(err);
                }
            });
        } catch (err) {
            callback(err);
        }
    };

    /**
    * 미인증 사용자의 비밀번호 재설정
    * @param username 
    * @param verification_code
    * @param new_password
    * @param callback function
    */
    this.confirm_password = (username, verification_code, new_password, callback) => {
        const cognito_user = new AWSCognito.CognitoUser(new cognito_user_model(username, user_pool));
        cognito_user.confirmPassword(verification_code, new_password, {
            onSuccess: function (result) {
                return callback(null, result);
            },
            onFailure: function (err) {
                return callback(err);
            }
        });
    };

    /**
    * 인증코드 재전송
    * @param username 
    * @param callback function
    */
    this.resend_confirmation_code = (username, callback) => {
        // console.log(username)
        const cognito_user = new AWSCognito.CognitoUser(new cognito_user_model(username, user_pool));
        cognito_user.resendConfirmationCode(callback);
    };

    /**
     * 코그니토 사용자 부가정보를 코그니토 객체로 변환한다.
     * @param model @see cognito_email_model
     */
    this.cognito_user_attribute = (model) => {
        return new AWSCognito.CognitoUserAttribute(model);
    };

    /**
     * 코그니토 사용자 부가정보를 코그니토 객체로 변환한다.
     * @param models @see cognito_email_model
     */
    this.cognito_user_attributes = (...model) => {
        return model.map((model) => {
            return this.cognito_user_attribute(model);
        });
    };

    /**
     * 코그니토에 로그인되어있을 경우 세션정보를 가져온다
     * @param callback function
     */
    this.cognito_user_get_session = (callback) => {
        const cognito_user = user_pool.getCurrentUser();
        // console.log(cognito_user)
        if (cognito_user != null) {
            return cognito_user.getSession(callback);
        } else {
            return callback(true);
        }
    };

    /**
     * 코그니토에 로그인되어있을 경우 세션정보를 가져온다
     * @param callback function
     */
    this.cognito_user_get_session_promise = () => {
        const cognito_user = user_pool.getCurrentUser();

        return new Promise((resolve, reject) => {
            // console.log(cognito_user)
            if (cognito_user != null) {
                cognito_user.getSession((err, result) => {
                    if (err) return reject(err);
                    return resolve(result);
                });
            } else {
                return reject(true);
            }
        })

    };

    /**
     * 코그니토에 refreshToken으로 세션을 갱신한다
     * @param callback function
     */
    this.cognito_user_refresh_session = (refreshToken, callback) => {
        const cognito_user = user_pool.getCurrentUser();
        return cognito_user.refreshSession(refreshToken, callback);
    };

    /**
     * 코그니토 사용자 세션 내 username을 가져온다.
     * @param callback function
     * @return group string
     */
    this.cognito_user_get_username = (callback) => {
        const cognito_user = user_pool.getCurrentUser();
        cognito_user.getSession(function (error, session) {
            if (error) {
                return callback(true);
            } else {
                var username = session.getIdToken().payload['cognito:username'];
                return callback(null, username);
            }
        })
    };

    /**
     * 코그니토 사용자 세션 내 그룹명을 가져온다.
     * @param callback function
     * @return group string
     */
    this.cognito_user_get_group = (callback) => {
        const cognito_user = user_pool.getCurrentUser();
        cognito_user.getSession(function (error, session) {
            if (error) {
                return callback(true);
            } else {
                var groups = session.getIdToken().payload['cognito:groups'];
                var group = '';
                if (!groups) {
                    alert('접근 권한이 없습니다. 코그니토 관리자 그룹설정이 올바른지 확인하세요.');
                    return;
                }
                if (groups.indexOf('system') > -1) {
                    group = 'system';
                } else if (groups.indexOf('manager') > -1) {
                    group = 'manager';
                } else if (groups.indexOf('admin') > -1) {
                    group = 'admin';
                }
                return callback(null, group);
            }
        })
    };

    this.getToken = (callback) => {
        // const clientId = cognito_pool_data.ClientId;
        // const provider = 'CognitoIdentityServiceProvider';
        // const key = `${provider}.${clientId}.LastAuthUser`;
        // const user = localStorage.getItem(key);
        // const idToken = localStorage.getItem(`${provider}.${clientId}.${user}.idToken`);
        // console.log(idToken)
        // return idToken;
        const cognito_user = user_pool.getCurrentUser();
        if(cognito_user) {
            cognito_user.getSession(function (error, session) {
                if (error) {
                    return callback(true);
                } else {
                    return callback(null, session.getIdToken());
                }
            })
        }
    }

    this.getTokenPromise = () => {
        return new Promise((resolve, reject) => {
            const cognito_user = user_pool.getCurrentUser();
            if(cognito_user) {
                cognito_user.getSession(function (error, session) {
                    if (error) {
                        return reject(true);
                    } else {
                        return resolve(session.getIdToken());
                    }
                })
            }

        });

    }
    this.getGroupPromise = () => {
        return new Promise((resolve, reject) => {
            const cognito_user = user_pool.getCurrentUser();
            if(cognito_user) {
                cognito_user.getSession(function (error, session) {
                    if (error) {
                        return reject(true);
                    } else {

                        var groups = session.getIdToken().payload['cognito:groups'];
                        var group = '';
                        if (!groups) {
                            alert('접근 권한이 없습니다. 코그니토 관리자 그룹설정이 올바른지 확인하세요.');
                            return;
                        }
                        if (groups.indexOf('system') > -1) {
                            group = 'system';
                        } else if (groups.indexOf('manager') > -1) {
                            group = 'manager';
                        } else if (groups.indexOf('admin') > -1) {
                            group = 'admin';
                        }
                        return resolve(group);
                    }
                })
            }else {
                return resolve(null);
            }
            

        });

    }

    this.getUserEmail = (username, callback) => {

        AWS.config.update({
            region: cognito_admin_pool_data['region'],
            credentials: new AWS.CognitoIdentityCredentials({
                IdentityPoolId: cognito_admin_pool_data['IdentityPoolId'],
            }),
        });
        AWS.config.credentials.get(function(err) {
            if (err) return console.error('cognito_role_group Error ::: ', err);
        })
        const cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider();
        const params = {
            UserPoolId: this.get_user_pool_id(), // Your User Pool ID
            Username: username,
        };
        // console.log(params)
        cognitoIdentityServiceProvider.adminGetUser(params, callback);
    };    
    this.getUserName = () => {
        const clientId = cognito_pool_data.ClientId;
        const provider = 'CognitoIdentityServiceProvider';
        const key = `${provider}.${clientId}.LastAuthUser`;
        const username = localStorage.getItem(key);
        return username;
    }

    this.getOrgName = () => {

        return new Promise((resolve, reject) => {
            const cognito_user = user_pool.getCurrentUser();
            if(cognito_user) {
                cognito_user.getSession(function (error, session) {
                    if (error) {
                        return reject(true);
                    } else {
                        var orgName = session.getIdToken().payload['custom:organization'];
                        return resolve(orgName);
                    }
                })
            }else {
                return resolve(null);
            }
            

        });
    }

    this.get_user_pool_id =() => {
        return cognito_pool_data['UserPoolId'];
    }

    /**
     * get cognito user pool group
     * 
     */
    this.cognito_role_group = () => {
        return new Promise((resolve, reject) => {
            // AWS Cognito 및 IAM 인증 설정
            AWS.config.update({
                region: cognito_admin_pool_data['region'],
                credentials: new AWS.CognitoIdentityCredentials({
                    IdentityPoolId: cognito_admin_pool_data['IdentityPoolId'],
                }),
            });
            AWS.config.credentials.get(function(err) {
                if (err) return console.error('cognito_role_group Error ::: ', err);
            })
            const params = {
                UserPoolId: cognito_admin_pool_data['UserPoolId'],
              };
            
            // CognitoIdentityServiceProvider를 사용하여 그룹 정보 가져오기
            const cognitoIdentityServiceProvider = new AWS.CognitoIdentityServiceProvider();
    
            // cognito user pool - group 목록 가져오기
            cognitoIdentityServiceProvider.listGroups(params, (err, data) => {
                if (err) {
                    return reject(err)
                } else {
                    // 여기서 data.Groups에는 Cognito 그룹 목록이 포함됩니다.
                    return resolve(data.Groups);
                }
            });
        })
    }

};

/**
* cognito attribure email model 
* @param {*} email 
*/
const cognito_email_model = function (email) {
    return cognito_user_attribure_model('email', email);
};

/**
* cognito user attribure
* @param {*} email 
*/
const cognito_user_attribure_model = function (name, value) {
    return {
        Name: name,
        Value: value
    }
};

/**
* cognito user model 
* @param {*} username
* @param {*} user_pool 
*/
const cognito_user_model = function (username, user_pool) {
    return {
        Username: username,
        Pool: user_pool
    }
};

/**
* cognito user login model 
* @param {*} username
* @param {*} password 
*/
const cognito_login_model = function (username, password) {
    return {
        Username: username,
        Password: password
    }
};

class_imon_user_cognito_handler.cognito_pool_data = cognito_admin_pool_data;
module.exports = class_imon_user_cognito_handler;